import { Alert, AlertModal, ConditionalComponent, FormElems, Modal } from "components";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { change, Field, initialize, reduxForm, stopSubmit } from "redux-form";
import React, { useState, useEffect } from 'react';
import closeImgIcon from 'static/images/close.svg';
import './updateBinForm.scss'
// import './createRoleForm.scss';
import { isEmpty } from "lodash";
import { ENTITY_TYPE } from "utils/constants/commonValues";
// import { fetchEntityListRequest } from "containers/MerchantOnboard/redux/merchantOnBoard.actions";
import { fetchEntityListRequest } from 'containers/MerchantOnboard/redux/entity/entity.actions';
import { getBinData, triggerResetBinData, updateBinValues } from "./redux/updateBin.actions";
import { updateBinValidator, validateBin } from "./validator";
const UpdateBinForm = ({ formData, entityData, actions, handleSubmit, updateBinReducer, modalIsOpen, closeModal, valid }) => {
    const { updateLoading, binData } = updateBinReducer
    const [selectedEntity, setSelectedEntity] = useState(null);
    const { entityList, loading } = entityData;
    const entityType = ENTITY_TYPE.MERCHANT
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();

    

    useEffect(() => {
        
        actions.fetchEntityListRequest(entityType)
        // console.log('entityData',entityData)
    }, [actions, entityType])
    
    useEffect(() => {
        if (selectedEntity?.entityCode) {

            const payload = {
                "entityCode": selectedEntity?.entityCode
            }
            actions.getBinData(payload);


        }
    }, [selectedEntity])
    useEffect(() => {
        if (updateBinReducer?.error) {
            handleClose()
        }
        else if (binData?.cardBin) {
            dispatch(change('update-bin', 'binValues', binData?.cardBin.join(", ")))
            dispatch(change('update-bin', "binStatus", binData?.binState))
        }
    }, [binData, updateBinReducer])

    useEffect(() => {
        if (binData?.cardBin && binData?.binState == formData?.values?.binStatus) {
            dispatch(change('update-bin', 'binValues', binData?.cardBin.join(", ")))
        } else {
            dispatch(change('update-bin', 'binValues', ""))
        }
    }, [formData?.values?.binStatus])
    useEffect(() => {
        let binValidation = validateBin(formData?.values?.binValues);
        if (!binValidation.isValid) dispatch(stopSubmit('update-bin', { binValues: binValidation.errorMsg }));

    }, [formData?.values?.binValues])
    

    const handleConfirm = () => {

        setShowModal(false)

        const binValues = formData?.values?.binValues
            ? formData?.values.binValues.split(",").map(val => val.trim())
            : [];
        const payload = {
            binState: formData?.values?.binStatus,
            entityCode: formData?.values?.entityId,
            cardBins: binValues || []
        }

        actions.updateBinValues(payload)
        // dispatch(reset('update-bin'));
        handleClose()


    }
    const onFormSubmit = () => {
        setShowModal(true);
    };
    const isDisabledBtn = () => {
        const validBin = formData.values?.binStatus == "ALLOW_ALL_BINS" ? false : !validateBin(formData.values?.binValues)?.isValid
        return isEmpty(formData?.values?.entityCode) || validBin || updateLoading
    }
    const handleClose=()=>{
         actions.triggerResetBinData();
        closeModal()
    }
    return (
        <>
            <Modal
                modalIsOpen={modalIsOpen}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                closeModal={handleClose}
                customWrapperClass="content-modal"
            >
                <div className="modal-header">
                    <h2 className="modal-heading">Update Bin</h2>
                    <img
                        src={closeImgIcon}
                        alt="Close"
                        onClick={handleClose}
                    />
                </div>
                <div className="modal-body">
                    <form
                        className="update-bin"
                        onSubmit={handleSubmit(onFormSubmit)}
                    >
                        <div className="form-section">
                            <div className="form-section">
                                <div className="form-section">
                                    <div className="form-field">
                                        <Field
                                            name="entityId"
                                            data={entityList}
                                            label={`Merchant Name`}
                                            labelField="name"
                                            valueField="entityCode"
                                            component={FormElems.DynamicSelect}
                                            onSearch={(entityName) => {
                                                actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT, { entityName });
                                            }}
                                            placeholder="Enter Name"
                                            optionsLoading={loading}
                                            resetOn={entityType}
                                            searchDelay={300}
                                            onSelect={(option) => setSelectedEntity(option)} // Callback to handle selection
                                            defaultOption={selectedEntity}
                                        />

                                    </div>
                                </div>
                                <div className="form-section">
                                    <div className="form-field">
                                        <Field
                                            name="entityCode"
                                            data={entityList}
                                            label={`Merchant ID`}
                                            labelField="entityCode" // reverse label
                                            valueField="name"       // reverse value
                                            component={FormElems.DynamicSelect}
                                            onSearch={(entityCode) => {
                                                actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT, { entityCode });
                                            }}
                                            placeholder="Enter ID"
                                            optionsLoading={loading}
                                            resetOn={entityType}
                                            searchDelay={300}
                                            onSelect={(option) => setSelectedEntity(option)} // Callback to handle selection
                                            defaultOption={selectedEntity}
                                        />

                                    </div>
                                </div>
                                <div className="form-section">
                                    <div className="form-field">

                                        <Field
                                            name="binStatus"
                                            options={[
                                                {
                                                    label: "Allowed Bins",
                                                    value: "ALLOWED_BINS"
                                                }, {
                                                    label: "Blocked Bins",
                                                    value: "BLOCKED_BINS"
                                                },
                                                {
                                                    label: "Allow All Bins",
                                                    value: "ALLOW_ALL_BINS"
                                                },]}
                                            valueField="value"
                                            labelField="label"
                                            component={FormElems.Radio}
                                            placeholder="Update Bin"
                                            wrapperClass="bin-status"

                                        />

                                    </div>
                                </div>
                                <ConditionalComponent isVisible={formData?.values?.binStatus != "ALLOW_ALL_BINS"}>
                                    <div className="form-section">
                                        <div className="form-field">
                                            <Field
                                                name="binValues"
                                                showOnlyReduxValue={true}
                                                // type="textarea"
                                                component={FormElems.TextArea}
                                                placeholder="Enter Bin Value"
                                                rows={3}
                                            // validate={[required, maxBins, validBinFormat]}
                                            />
                                        </div>
                                    </div>
                                </ConditionalComponent>
                                <div className="form-section-actions">
                                    <FormElems.Button
                                        buttonType="secondary"
                                        id="back-btn"
                                        text="CANCEL"
                                        type="button"
                                        handleClick={handleClose}
                                        customClass="back-btn"
                                    />
                                    <FormElems.Button
                                        buttonType="primary"
                                        isDisable={isDisabledBtn()}
                                        text="SUBMIT"
                                        id="next-btn"
                                    />
                                </div>


                            </div>

                        </div>

                    </form>

                    {<AlertModal
                        modalIsOpen={showModal}
                        closeModal={() => { setShowModal(false) }}
                        primaryButtonText="OK"
                        secondaryButtonText="CANCEL"
                        showActions={true}
                        onSuccessModal={handleConfirm}
                        headerText={`Confirm`}
                        // currentSection={currentStep}
                        message={`Do you want to confirm the bin update?`}
                    />}
                </div>
            </Modal>
        </>
    );
}

const mapStateToProps = ({ form, entityData, updateBinReducer }) => ({
    updateBinReducer,
    entityData,
    formData: form['update-bin'],
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchEntityListRequest,
            updateBinValues,
            getBinData,
            triggerResetBinData
        },
        dispatch
    ),
});
export default compose(
    reduxForm({
        form: 'update-bin',
        initialValues: {
            binStatus: 'ALLOW_ALL_BINS' // 👈 Default value for radio
        },
        // validate: updateBinValidator,
        enableReinitialize: true,
        // keepDirtyOnReinitialize: true, // 👈 important!
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UpdateBinForm);